import { createStore } from '@stencil/store';

const { state } = createStore({
  website: {},
  browser: {},
  auth: {},
  Router: {},
  productComparison: {}
});

// onChange('clicks', value => {
//   state.squaredClicks = value ** 2;
// });

export default state;
